import axios from 'axios';
import { toast } from 'react-toastify';
import * as _ from 'lodash';

const BASEURL = process.env.REACT_APP_API_URL;
const USERS_URL = process.env.REACT_APP_USERS_URL;
const PAYMENTS_URL = process.env.REACT_APP_PAYMENTS_URL;

const catchError = (error: any): void => {
  
  const { status, data } = error.response;

  switch (status) {
    case 401:
      window.location.href = String(USERS_URL);
      break;
    default: {
      toast.error(data.message || data.error);
    }
  }

  throw error;
}

type RequestArgs = {
  method: string;
  params?: any;
  body?: any;
  path: string;
}
const request = ({ method, params, body, path }: RequestArgs) => {
  const options: any = {
    method,
    url: `${BASEURL}${path}`,
    headers: {
      jwt: localStorage.getItem('token'),
    },
  };

  if (params) {
    if (params.where) {
      params.where = Object.keys(params.where).reduce((acc, key) => {
        if (params.where[key] || params.where[key] === 0) {
          acc[key] = params.where[key];
        }

        return acc;
      }, {});
    }
    options.params = params;
  }

  if (body) {
    options.data = body;
  }

  return axios(options).catch(catchError);
}

export function listContents(params: any): Promise<any> {
  return request({
    params,
    path: '/api/admin/contents',
    method: 'GET',
  });
}

export function searchContentsByLanguage(params: any): Promise<any> {
  return request({
    params,
    path: '/api/admin/contents/search-by-language',
    method: 'GET',
  });
}

export function createContent(body: any): Promise<any> {
  return request({
    body,
    method: 'POST',
    path: '/api/admin/contents',
  });
}

export function getContent(id: number): Promise<any> {
  return request({
    method: 'GET',
    path: `/api/admin/contents/${id}`,
  });
}

export function updateContent(id: number, body: any): Promise<any> {
  return request({
    body,
    method: 'PUT',
    path: `/api/admin/contents/${id}`,
  });
}

export function deleteContent(id: number): Promise<any> {
  return request({
    method: 'DELETE',
    path: `/api/admin/contents/${id}`,
  });
}

export function listModules(params: any): Promise<any> {
  return request({
    params,
    method: 'GET',
    path: '/api/admin/modules',
  });
}

export function createModule(body: any): Promise<any> {
  return request({
    body,
    method: 'POST',
    path: '/api/admin/modules',
  });
}

export function getModule(id: number): Promise<any> {
  return request({
    method: 'GET',
    path: `/api/admin/modules/${id}`,
  });
}

export function updateModule(id: number, body: any): Promise<any> {
  return request({
    body: _.omit(body, 'content_id'),
    method: 'PUT',
    path: `/api/admin/modules/${id}`,
  });
}

export function deleteModule(id: number): Promise<any> {
  return request({
    method: 'DELETE',
    path: `/api/admin/modules/${id}`,
  });
}

export function reorderModules(body: any): Promise<any> {
  return request({
    body,
    method: 'POST',
    path: '/api/admin/modules/reorder',
  });
}

export function me(): Promise<any> {
  return request({
    method: 'GET',
    path: '/api/admin/auth/me',
  });
}

export function listCards(): Promise<any> {

  if(PAYMENTS_URL === ''){
    return Promise.reject('error');
  }

  const options: any = {
    method: 'GET',
    url: `${PAYMENTS_URL}/api/cards`,
    params: {
      where: JSON.stringify({
        active: true,
      }),
      attributes: 'id,name',
      order: 'name ASC',
      limit: 1000,
    }
  };

  return axios(options).catch(catchError);
};

export function listBanks(): Promise<any> {

  if(PAYMENTS_URL === ''){
    return Promise.reject('error');
  }

  const options: any = {
    method: 'GET',
    url: `${PAYMENTS_URL}/api/banks`,
    params: {
      attributes: 'id,name',
      order: 'name ASC',
      limit: 1000,
    }
  };

  return axios(options).catch(catchError);
}

export function listCompanies(): Promise<any> {

  if(PAYMENTS_URL === ''){
    return Promise.reject('error');
  }

  const options: any = {
    method: 'GET',
    url: `${PAYMENTS_URL}/api/companies`,
    params: {
      attributes: 'id,name',
      order: 'name ASC',
      limit: 1000,
    }
  };

  return axios(options).catch(catchError);
}

export function listContentSubtypes(params: any): Promise<any> {
  return request({
    params,
    method: 'GET',
    path: '/api/admin/contents-subtypes',
  });
}

export function createContentSubtype(body: any): Promise<any> {
  return request({
    body,
    method: 'POST',
    path: '/api/admin/contents-subtypes',
  });
}

export function getContentSubtype(id: number): Promise<any> {
  return request({
    method: 'GET',
    path: `/api/admin/contents-subtypes/${id}`,
  });
}

export function updateContentSubtype(id: number, body: any): Promise<any> {
  return request({
    body: _.omit(body, 'id'),
    method: 'PUT',
    path: `/api/admin/contents-subtypes/${id}`,
  });
}

export function getTags(params: any): Promise<any> {
  return request({
    params,
    method: 'GET',
    path: '/api/admin/tags',
  });
}

export function getTag(id: number): Promise<any> {
  return request({
    method: 'GET',
    path: `/api/admin/tags/${id}`,
  });
}

export function createTag(body: any): Promise<any> {
  return request({
    body,
    method: 'POST',
    path: '/api/admin/tags',
  });
}

export function updateTag(id: number, body: any): Promise<any> {
  return request({
    body,
    method: 'PUT',
    path: `/api/admin/tags/${id}`,
  });
}


// WEBPACK FOOTER //
// ./src/api.ts